import { bindActionCreators, Dispatch } from "redux";
import { connect, RootStateOrAny } from "react-redux";

import { Typography } from "antd";

import { UserModel } from "utils/types";

import { getRafScoreList, getRafScoreDetail } from "store/eligibility/rafScore/actions";
import { getFile } from "store/eligibility/rafScore/actions";

import RiskScoreProvidersTable from "components/Hcc/RiskScore/RiskScoreProvidersTable";

import './index.scss';

interface RiskScorePageProps {
  getRafScoreList(userModal: UserModel): any,
  getRafScoreDetail(providerKeyId: string): any,
  getFile(providerKeyId: string): any,
  isFetchingList: boolean,
  isFetching: boolean,
  isFetchingFile: boolean
}

const { Title } = Typography;

const RiskScorePage = (props: RiskScorePageProps) => {

  return (
    <>
      <div className="hcc-page">
        <div className="header-title">
          <Title level={4} className="ml-3">Risk Score</Title>
        </div>
      </div>

      <RiskScoreProvidersTable
        getRafScoreList={props.getRafScoreList}
        getRafScoreDetail={props.getRafScoreDetail}
        getFile={props.getFile}
        isFetchingList={props.isFetchingList}
        isFetching={props.isFetching}
        isFetchingFile={props.isFetchingFile}
      />
    </>
  );
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetchingList: store.rootReducer.eligibilityRAFScore.isFetchingList, //raf score list IPA/provider table
  isFetching: store.rootReducer.eligibilityRAFScore.isFetching, //Raf Score Detail modal
  isFetchingFile: store.rootReducer.eligibilityRAFScore.isFetchingFile //Export excel
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    getRafScoreList,
    getRafScoreDetail,
    getFile
  },
  dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(RiskScorePage);
